import { useState, useEffect } from 'react'
import logoLargeWhite from '@assets/images/mandrake-logo-large-white.svg'
import { colors, fontSize, getRemValue, size } from '@styles/theme'
import logoDark from '@assets/images/mandrake-logo.svg'
import useScreenSize from '@hooks/useScreenSize'
import styled from '@emotion/styled'
import AnonymousUserModal from '@components/auth/AnonymousUserModal'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import LoginModal from '@components/auth/LoginModal'
import SignupModal from '@components/auth/SignupModal'
// import { GoogleLogin } from '@react-oauth/google'
import ScreenContainer from './ScreenContainer'
import { Button } from '@mui/material'
import ThirdPartyAgeVerificationModal from '@components/auth/OauthAgeVerificationModal'
import SignupAgeVerificationModal from '@components/auth/SignupAgeVerificationModal'
import WelcomeModal from '@components/auth/WelcomeModal'
import StyledAlert from '@elements/StyledAlert'

const backgroundArr = [
  'https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-1-480w.jpeg',
  'https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg',
  'https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-3-480w.jpeg',
  'https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-4-480w.jpeg',
  // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699669017/amir-esrafili-m60HA5jFIRg-unsplash.jpg',
]

const LandingContainer = styled(ScreenContainer)`
  align-items: center;
  padding: ${size(4)};
  background:
    linear-gradient(180deg, #000 0%,
    rgba(0, 0, 0, 0.00) 124.81%),
    url(${backgroundArr[(Math.floor(Math.random() * backgroundArr.length))]}),
    lightgray 50%;
  background-repeat: no-repeat;
  background-cover: center;
  background-size: cover;
  background-position: center;
  background-color: black;
  overflow-y: auto;
`

const MainLogo = styled.img`
  height: ${size(12.5)};
  width: ${size(12.5)};
`
  
const LogoIcon = styled.img`
  height: ${size(2.25)};
  width: ${size(2.25)};
  margin-right: ${size(1)};
`

const AppTitle = styled.h1`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: ${size(1)};
  margin-top: ${size(1)};
`

const AppTagline = styled.em`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 700;
  font-size: ${fontSize('sm')};
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  // Original style before adding beta test message
  // margin: ${size(6)} 0;
  margin: ${size(2)} 0 ${size(6)} 0;
`

const Or = styled.span`
  font-weight: 700;
  font-size: ${fontSize('xl')};
  margin: ${size(1)} 0;
`

const LandingButton = styled(Button)`
  display: flex;
  alignt-items: center;
  width: 100%;
  max-width: 400px;
  font-size: ${fontSize('md')};
  font-weight: 700;
  height: ${size(6.5)};
  border-radius: 100px;
  box-shadow: 0px 2px 15px 4px rgba(13, 64, 115, 0.70);
  background: linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%);
`

const GoogleLoginContainer = styled.div`
  margin-top: ${size(1)};
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  min-height: 44px;
`

const AboutContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${size(2)};
`

const AboutLink = styled(Link)`
  color: white;
  width: 100%;
  text-align: center;
  text-decoration: none;
  border-bottom: 1px solid white;
  font-size: ${fontSize('sm')};
  font-weight: 500;
`
const Disclosures = styled.span`
  color: white;
  width: 100%;
  text-align: center;
  font-size: ${fontSize('sm')};
  padding: 0 ${size(6)};
  white-space: nowrap;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`

const DisclosureLink = styled(Link)`
  color: white;
`

const Landing = () => {
  const [googleButtonWidth, setGoogleButtonWidth] = useState(undefined)
  const { width } = useScreenSize()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const anonymousIsOpen = searchParams.get('modal-anonymous')
  const signupAgeVerifyIsOpen = searchParams.get('modal-signup-age-verify')
  const thirdPartyAgeVerifyIsOpen = searchParams.get('modal-third-party-age-verify')
  const loginIsOpen = searchParams.get('modal-login')
  const signupIsOpen = searchParams.get('modal-signup')
  const welcomeModalIsOpen = searchParams.get('modal-welcome')
  // const anyModalIsOpen = (
  //   anonymousIsOpen ||
  //   loginIsOpen ||
  //   signupIsOpen ||
  //   signupAgeVerifyIsOpen ||
  //   thirdPartyAgeVerifyIsOpen
  // )

  // This sets the width of the google sign in button
  // The value of the width is the screen size minus the margin size (set by the LandingContainer)
  useEffect(() => {
    const newWidth = width - (getRemValue() * 4)
    setGoogleButtonWidth(newWidth)
  }, [width])

  const parseJwt = (token) => {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
   const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
   }).join(''))
 
   return JSON.parse(jsonPayload)
 }

  const responseGoogle = (response) => {
    console.log(response, "I AM RESPONSE FROM GOOGLE")
    console.log(parseJwt(response?.credential))
    navigate('#modal-third-party-age-verify')
  }

  return (
    <LandingContainer>
      <LoginModal isOpen={loginIsOpen} />
      <SignupModal isOpen={signupIsOpen} />
      <AnonymousUserModal isOpen={anonymousIsOpen} />
      <ThirdPartyAgeVerificationModal isOpen={thirdPartyAgeVerifyIsOpen} />
      <SignupAgeVerificationModal isOpen={signupAgeVerifyIsOpen} />
      <WelcomeModal isOpen={welcomeModalIsOpen} />
      <MainLogo src={logoLargeWhite} alt='Mandrake Logo' />
      <AppTitle>
        Mandrake
      </AppTitle>
      <AppTagline>Find What You're Looking For</AppTagline>
      <StyledAlert
        kind='info'
        AlertStyles={{ fontSize: fontSize('sm'), marginTop: size(2), justifyContent: 'center', borderRadius: 15, width: 'fit-content' }}>
        Welcome to the Beta Test
      </StyledAlert> 
      {/* <StyledAlert
        kind='info'
        AlertStyles={{ fontSize: fontSize('sm'), marginTop: size(0.5), justifyContent: 'center', borderRadius: 15, width: 'fit-content' }}>
        Send the dev some feedback {'<'}3
      </StyledAlert>  */}
      <ButtonContainer>
        <LandingButton
          onClick={() => navigate('?modal-anonymous=true&remove_background=true')}
          variant='contained'>
          Use Anonymously
        </LandingButton>
        <Or>or</Or>
        <LandingButton
          onClick={() => navigate('?modal-login=true&remove_background=true')}
          variant='contained'>
          Log In
        </LandingButton>
        {/* <StyledAlert
          kind='info'
          slotProps={{ icon: { style: { display: 'none' } } }}
          AlertStyles={{ fontSize: fontSize('xs'), marginTop: size(0.5), justifyContent: 'center', textAlign: 'center' }}>
          Help the developer by giving feedback.
        </StyledAlert> */}
        {/* <GoogleLoginContainer>
          <GoogleLogin
            containerProps={{ style: { flexShrink: 1 } }}
            width={parseInt(googleButtonWidth)}
            onSuccess={responseGoogle}
            onError={console.log}
            text='continue_with'
            shape='pill'
            size='large'
            useOneTap
          />
        </GoogleLoginContainer> */}
      </ButtonContainer>
      <AboutContainer>
        <LogoIcon src={logoDark} alt='Mandrake Logo Icon' />
        <AboutLink to='/about'>About The Mandrake App</AboutLink>
      </AboutContainer>
      <Disclosures>
        <span>
          You must be at least 18 years old<br />to use this application.<br /><br />
        </span>
        <span>
          By entering, you agree to our <br />
          <DisclosureLink>Terms of Service</DisclosureLink>, <DisclosureLink>Privacy Policy</DisclosureLink><br />
          and <DisclosureLink>Copyright Policy</DisclosureLink>
        </span>
      </Disclosures>
    </LandingContainer>
  )
}

export default Landing
